import request from '@/util/request2';
// 保存表格信息
export function saveTableColumnMsg (params, config) {
  return request({
    url: '/api/auth/mis/misConfigure/saveOrUpdate',
    method: 'post',
    data: params
  });
}

// 获取表格信息
export function getTableColumnMsg (params, config) {
  return request({
    url: '/api/auth/mis/misConfigure/list',
    method: 'get',
    params,
  });
}

/**
 * 删除配置信息
 * @param params
 * @return {Promise}
 */
export function removeMisConfigure (params, config) {
  params.ids = params.ids.toString();
  return request({
    url: '/api/auth/mis/misConfigure/remove',
    method: 'get',
    params: params
  });
}

/**
 * 查询用户信息配置表的列表,包含配置信息和扩展信息
 * @param params
 */
export function misConfigureListUser (params, config) {
  return request({
    url: '/api/auth/mis/misConfigure/listUser',
    method: 'get',
    params: params
  });
}

/**
 * 根据name查询用户信息配置表的列表
 * @param params
 */
export function misConfigureListAll (params, config) {
  return request({
    url: '/api/auth/mis/misConfigure/listAll',
    method: 'get',
    params: params
  });
}

/**
 * 表格配置扩张信息保存或更新
 * @param params
 */
export function misConfigureExtensionSaveOrUpdate (params) {
  return request({
    url: '/api/auth/mis/misConfigureExtension/saveOrUpdate',
    method: 'post',
    data: params,
    settings: {type: 'json'}
  });
}

/**
 * 更新范围
 * @param params
 */
export function misConfigureUpdateScope (params, config) {
  return request({
    url: '/api/auth/mis/misConfigure/updateScope',
    method: 'post',
    data: params,
    settings: {type: 'json'}
  });
}

/**
 * 查询字段是否显示的配置
 * @param params
 */
/*export function getByMenucode (params) {
  return request(createPost(CORE, '/mis/misFieldShowSetting/getByMenucode', params));
}*/
